import { Component, OnInit } from '@angular/core';
import { LocalService } from '../../core';
import { ApproverService } from '../../core/services/approver.service';

@Component({
  selector: 'app-approver',
  templateUrl: './approver.component.html',
  styleUrls: ['./approver.component.scss']
})
export class ApproverComponent implements OnInit {

  userProfile: any = null;
  activityList: any = [];
  activityName: any;
  selectedActivityId: any;
  selectedActivity: any = null;
  approvedCount: any = 0;
  rejectedCount: any = 0;
  pendingApprovalCount: any = 0;

  approveModalOpen = false;
  rejectModalOpen = false;
  chatModalOpen = false;
  selectedApproverData: any = null;
  selectedChatData: any = null;
  reloadTrigger = 0;

  size = 5;

  constructor(private approverService: ApproverService) {}

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    this.getActivityChgList();
  }

  getActivityChgList() {
    this.approverService.getActivityList().subscribe((res) => {
      if (res.length > 0) {
        this.activityList = res;
        this.selectedActivity = res[0];
        this.selectedActivityId = res[0].id;
        this.activityName = res[0].name;
        this.getCountofApprovals();
      }
    });
  }

  onChangeActivity(item: any) {
    this.selectedActivity = item;
    this.selectedActivityId = item.id;
    this.activityName = item.name;
    this.approvedCount = 0;
    this.pendingApprovalCount = 0;
    this.rejectedCount = 0;
    this.getCountofApprovals();
  }

  getCountofApprovals() {
    this.approverService.getApprovalCount(this.selectedActivityId).subscribe(res => {
      if (res) {
        res.forEach((val: any) => {
          if (val.status == 'APPROVED') { this.approvedCount = val.count; }
          if (val.status == 'PENDING_APPROVAL') { this.pendingApprovalCount = val.count; }
          if (val.status == 'REJECTED') { this.rejectedCount = val.count; }
        });
      }
    });
  }

  onOpenApprove(row: any) {
    this.selectedApproverData = row;
    this.approveModalOpen = true;
  }

  onApproveClose() {
    this.approveModalOpen = false;
    this.selectedApproverData = null;
  }

  onApproveConfirmed() {
    this.approveModalOpen = false;
    this.selectedApproverData = null;
    this.reloadTrigger++;
    this.getCountofApprovals();
  }

  onOpenReject(row: any) {
    this.selectedApproverData = row;
    this.rejectModalOpen = true;
  }

  onRejectClose() {
    this.rejectModalOpen = false;
    this.selectedApproverData = null;
  }

  onRejectConfirmed() {
    this.rejectModalOpen = false;
    this.selectedApproverData = null;
    this.reloadTrigger++;
    this.getCountofApprovals();
  }

  onOpenChat(row: any) {
    this.selectedChatData = { fileData: { name: 'chatModal', approverData: row } };
    this.chatModalOpen = true;
  }

  onChatClose() {
    this.chatModalOpen = false;
    this.selectedChatData = null;
  }
}
